// test662
(662 && 0);
